module.exports = __webpack_public_path__ + "img/1.2fc0ee68.jpg";